import * as XLSX from "xlsx";
import { blumStockService } from "../pages/verve-inventory/services/blumStockService";
import toast from "react-hot-toast";

export const exportBlumStockData = async (filters) => {
  try {
    const params = {
      ...filters,
      limit: 100000, // Fetch all for export
      page: 1
    };

    const response = await blumStockService.getStock(params);
    const stockItems = response?.data || [];

    if (stockItems.length === 0) {
      toast.error("No data available to export based on current filters.");
      return;
    }

    // Group items by category
    const groupedItems = stockItems.reduce((acc, item) => {
      const category = item.category || "Uncategorized";
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item);
      return acc;
    }, {});

    const wb = XLSX.utils.book_new();
    const seenSheetNames = new Set();

    // Create a sheet for each category
    Object.keys(groupedItems).forEach((category) => {
      const items = groupedItems[category];
      
      const wsData = [
        // Main Title mimicking the Excel screenshot
        ["BLUM MRP PRICELIST"],
        // Header for UoM | MOQ | MRP info
        ["UoM: *Unit of Measure | MOQ: *Minimum Order Quantity | MRP: *Maximum Retail Price"],
        // Category Header
        [category.toUpperCase()],
        // Sub Category Header (we can leave empty or put a general sub-category if needed)
        [""], 
        
        // Required header row
        ["Image", "Article ID", "Material Description", "Information", "UoM", "MOQ", "MRP", "Version"]
      ];

      items.forEach((item) => {
        wsData.push([
          item.image || "-",
          item.articleId || "-",
          item.materialDescription || "-",
          item.information || "-",
          item.uom || "-",
          item.moq || "-",
          item.mrp || "-",
          item.version || "-"
        ]);
      });

      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // Apply centering to all cells
      Object.keys(ws).forEach(key => {
        if (key[0] === '!') return; 
        if (!ws[key].s) ws[key].s = {};
        ws[key].s.alignment = {
          horizontal: "center",
          vertical: "center",
          wrapText: true
        };
      });

      // Merge cells for the title rows
      ws['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, // BLUM MRP PRICELIST
        { s: { r: 1, c: 0 }, e: { r: 1, c: 7 } }, // UoM info
        { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } }, // Category
        { s: { r: 3, c: 0 }, e: { r: 3, c: 7 } }, // Sub Category blank
      ];

      // Styling column widths
      const wscols = [
        { wch: 15 }, // Image
        { wch: 15 }, // Article ID
        { wch: 30 }, // Material Description
        { wch: 70 }, // Information
        { wch: 10 }, // UoM
        { wch: 10 }, // MOQ
        { wch: 15 }, // MRP
        { wch: 15 }, // Version
      ];
      ws['!cols'] = wscols;

      // Ensure sheet name is valid (Excel has a 31 char limit and doesn't allow certain chars)
      let baseName = category.replace(/[\\/*?:[\]]/g, '').trim();
      if (!baseName) baseName = "Sheet";
      
      let safeSheetName = baseName.substring(0, 31);
      
      let counter = 1;
      while (seenSheetNames.has(safeSheetName.toLowerCase())) {
        const suffix = ` (${counter})`;
        safeSheetName = baseName.substring(0, 31 - suffix.length) + suffix;
        counter++;
      }
      seenSheetNames.add(safeSheetName.toLowerCase());

      XLSX.utils.book_append_sheet(wb, ws, safeSheetName);
    });

    XLSX.writeFile(wb, "Blum_Prices_Export.xlsx");
    toast.success("Export successful!");
  } catch (error) {
    console.error("Export Error:", error);
    toast.error("Failed to export data");
  }
};
